// YES Foundation — The 3Es taxonomy
// Source: Annual Reports FY 2023-24 & FY 2024-25

export const PILLARS = [
  {
    id: "employability",
    name: "Employability",
    short: "E1",
    color: "#1E3A8A",        // YES navy / royal blue
    accent: "#3B82F6",
    bg: "from-blue-50 to-white",
    chipBg: "bg-blue-50",
    chipText: "text-blue-700",
    tagline: "Skilling underprivileged youth for market-relevant jobs",
    description:
      "Blended classroom + digital training in communication, computers and soft skills, paired with mentorship and placement support to bridge the youth-skill gap.",
    subThemes: [
      "Job-linked Skilling",
      "Digital Literacy",
      "Industry Mentorship",
      "Women in Workforce",
    ],
  },
  {
    id: "entrepreneurship",
    name: "Entrepreneurship",
    short: "E2",
    color: "#B45309",        // warm amber
    accent: "#F59E0B",
    bg: "from-amber-50 to-white",
    chipBg: "bg-amber-50",
    chipText: "text-amber-700",
    tagline: "Sustainable livelihoods for farmers, women & artisans",
    description:
      "Income enhancement through climate-resilient farming, watershed development, handicraft and handloom revival, and nano-enterprise capacity building.",
    subThemes: [
      "Agri Livelihoods",
      "Watershed Development",
      "Handicrafts & Handlooms",
      "Nano Enterprises",
      "Women SHGs",
    ],
  },
  {
    id: "environment",
    name: "Environment Sustainability",
    short: "E3",
    color: "#15803D",        // forest green
    accent: "#22C55E",
    bg: "from-green-50 to-white",
    chipBg: "bg-emerald-50",
    chipText: "text-emerald-700",
    tagline: "Climate resilience through trees, water & MSME efficiency",
    description:
      "Agroforestry on farmers' lands, native tree plantation, ecological restoration, and walk-through energy audits to make MSMEs more efficient.",
    subThemes: [
      "Agroforestry",
      "Ecological Restoration",
      "MSME Energy Efficiency",
      "Climate Education",
    ],
  },
];

export const getPillar = (id) => PILLARS.find((p) => p.id === id);
